import { useExperiments } from '@wix/fe-essentials-standalone';
import { useRouter } from 'next/router';
import { useContext, useState, useEffect } from 'react';

import { EXPERIMENTS, LOCALES } from '../constants';
import { Context } from '../context';
import { useWindowSize } from './useWindowSize';
import { isMobile, isTablet } from '../utils/user-agent';

const useIsRefinementQuestionsEnabled = () => {
  const context = useContext(Context);
  const { locale } = useRouter();
  const [isMobileView, setIsMobileView] = useState(isMobile);
  const [isTabletView, setIsTabletView] = useState(isTablet);
  const { experiments } = useExperiments({ suspense: false, readOnly: true });
  const windowSize = useWindowSize();

  useEffect(() => {
    if (windowSize.width) {
      setIsMobileView(isMobile(context));
      setIsTabletView(isTablet(context));
    }
  }, [context, windowSize.width]);

  return (
    !isMobileView &&
    !isTabletView &&
    locale === LOCALES.EN &&
    experiments.enabled(EXPERIMENTS.SPECS.ANSWER_GENERATION_REFINEMENT_QUESTIONS)
  );
};

export default useIsRefinementQuestionsEnabled;

